import React, { useEffect, useState } from 'react';
import { Badge } from '@/components/ui/badge';
import { AlertCircle, Zap } from 'lucide-react';

const EnvironmentBadge = () => {
  const [envInfo, setEnvInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEnvInfo = async () => {
      try {
        const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
        const response = await fetch(`${backendUrl}/api/system/info`);
        const data = await response.json();
        setEnvInfo(data);
      } catch (error) {
        console.error('Error fetching environment info:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchEnvInfo();
  }, []);

  if (loading || !envInfo) {
    return null;
  }

  const isProduction = envInfo.is_production;

  return (
    <Badge 
      data-testid="environment-badge"
      className={`
        flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold uppercase tracking-wider
        ${isProduction 
          ? 'bg-[hsl(var(--neon-accent))] hover:bg-[hsl(var(--neon-accent))]/90 text-white glow-accent border-none' 
          : 'bg-[hsl(var(--warning))] hover:bg-[hsl(var(--warning))]/90 text-black border-none'
        }
      `}
    >
      {isProduction ? (
        <Zap className="h-3 w-3 animate-pulse" />
      ) : (
        <AlertCircle className="h-3 w-3" />
      )}
      {isProduction ? 'MAINNET · Live' : 'TESTNET · Dev'}
    </Badge>
  );
};

export default EnvironmentBadge;
